<template>
  <div class="mall-my-list">
    <header class="mall-my-list__head">
      <h1>거래명세서 조회</h1>
      <p>결제 완료된 주문의 거래명세서를 인쇄할 수 있습니다.</p>
    </header>

    <div v-if="loading" class="mall-my-list__empty">불러오는 중입니다…</div>

    <div v-else-if="!orders.length" class="mall-my-list__empty">
      <AppIcon icon="mdi-file-document-outline" :size="48" />
      <p>출력할 거래명세서가 없습니다</p>
      <em>결제 완료된 주문만 여기에 나타납니다.</em>
      <router-link :to="MALL_HOME_PATH">쇼핑계속하기</router-link>
    </div>

    <ul v-else class="mall-my-list__cards">
      <li v-for="order in orders" :key="order.code">
        <div class="mall-my-list__meta">
          <strong>{{ order.code }}</strong>
          <time>{{ formatDate(order.paidAt || order.orderedAt) }}</time>
        </div>
        <p class="mall-my-list__title">
          {{ order.itemSummary || '주문 상품' }}
          <em v-if="order.itemCount > 1"> 외 {{ order.itemCount - 1 }}건</em>
        </p>
        <p class="mall-my-list__sub">
          {{ order.payMethod === 'TOSS' ? '결제 완료' : '입금 확인' }} · {{ formatPrice(order.totalAmount) }}원
        </p>
        <div class="mall-my-list__actions">
          <router-link :to="`/mall/orders/${order.code}`">거래명세서 보기 · 인쇄</router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { MALL_ORDER_STATUS_LABEL, fetchMyOrders, type MallOrder } from '@/api/mallOrder'
import { formatPrice } from '@/constants/mallProducts'
import { MALL_HOME_PATH } from '@/constants/mall'

const loading = ref(true)
const orders = ref<MallOrder[]>([])

function formatDate(value: string | null | undefined) {
  return String(value || '').slice(0, 10).replace(/-/g, '.')
}

onMounted(async () => {
  loading.value = true
  try {
    const rows = await fetchMyOrders()
    orders.value = rows.filter((order) => order.status === 'PAID')
  } catch {
    orders.value = []
  } finally {
    loading.value = false
  }
})
</script>

<style lang="scss" src="./MallMyListPage.scss"></style>
